module.exports = __webpack_public_path__ + "img/bonhomme-violet.7c10e999.png";